import PropTypes from 'prop-types';
import hexRgba from 'hex-rgba';
import { color as themeColor } from '../../../app/theme';

function ImagemapTemplate5({ selected, color, width, height }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 154 154"
    >
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g transform="translate(-928 -266) translate(240 23) translate(24 216) translate(664 27)">
                <rect
                  width={width}
                  height={height}
                  fill={selected ? color : hexRgba(color, 10)}
                  rx="8"
                />
                <text
                  fill={selected ? themeColor.$7 : themeColor.$11}
                  fontFamily="PingFangTC-Regular, PingFang TC"
                  fontSize="17"
                >
                  <tspan x="60" y="83">
                    自訂
                  </tspan>
                </text>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

ImagemapTemplate5.defaultProps = {
  selected: false,
  color: '#2A394D',
  width: 154,
  height: 154,
};

ImagemapTemplate5.propTypes = {
  selected: PropTypes.bool,
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ImagemapTemplate5;
